import React, { useContext, type JSX } from 'react'
import classNames from 'classnames'
import { ModalDialogContext } from './modal-dialog-context'

type PropsTitle = {
  title: string | JSX.Element
  children?: never
}

type PropsChildren = {
  title?: never
  children?: React.ReactNode
}

type Props = (PropsTitle | PropsChildren) & {
  className?: string
}

export const ModalDialogHeader = ({ className, ...props }: Props) => {
  const { ariaLabelledBy } = useContext(ModalDialogContext)

  return (
    <div className={classNames('c-dialog__header', className)}>
      {props.title ? (
        <div className="c-dialog__title">
          <h2 id={ariaLabelledBy} className="h3 u-mb-0">
            {props.title}
          </h2>
        </div>
      ) : null}
      {props.children ? <>{props.children}</> : null}
    </div>
  )
}
